import styled from 'styled-components';

export const ReviewTypeContainer = styled.div`
    .bar{
        margin-top: .5em;
    }
`;